import { useCopyToClipboard } from "../hooks/useCopyToClipboard";

function CopyableId({ label, value }: { label: string; value: string }) {
  const { copied, copy } = useCopyToClipboard(value);

  return (
    <span className="inline-flex items-baseline gap-1.5">
      <span>{label}</span>
      <button
        type="button"
        onClick={copy}
        data-tip="Click to copy"
        className="font-mono text-content-primary hover:bg-[#F4F4F6] rounded px-1 -mx-1 transition-colors"
      >
        {value}
      </button>
      {copied && <span className="text-xs text-success-dark">copied</span>}
    </span>
  );
}

/**
 * The ids an operator pastes into a console or a DevTools filter while
 * diagnosing this hotel: its Tag Manager container and its GA4 measurement
 * id. Both are self-identifying by prefix (`GTM-`, `G-`); the labels are
 * only there so the line still reads when one of them is missing. Renders
 * nothing when the hotel has neither — the tracking-mode chip beside the
 * name already says "no GA4 / no GTM".
 */
export function TrackingIds({
  gtmContainerPublicId,
  ga4MeasurementId,
}: {
  gtmContainerPublicId: string | null;
  ga4MeasurementId: string | null;
}) {
  if (!gtmContainerPublicId && !ga4MeasurementId) return null;

  return (
    <div className="text-sm text-content-secondary">
      {gtmContainerPublicId && (
        <CopyableId label="container" value={gtmContainerPublicId} />
      )}
      {gtmContainerPublicId && ga4MeasurementId && " · "}
      {ga4MeasurementId && (
        <CopyableId label="measurement" value={ga4MeasurementId} />
      )}
    </div>
  );
}
